import React from "react";
import AscComponent from "../../components/AscComponent";
import SetBreadCrumb from "../Elements/AscElements/SetBreadCrumb";
import InlineForm from "../Elements/FromGroup/InlineForm";
import { Button, ButtonGroup, Col, DropdownButton, MenuItem, Row } from "react-bootstrap";
import Overview from "./CallAnalysisSummaryElements/Overview";
import Compare from "./CallAnalysisSummaryElements/Compare";
import Summaries from "./CallAnalysisSummaryElements/Summaries";
import styled from "@emotion/styled";
import Menu from "./CallAnalysisSummaryElements/Menu";
import moment from "moment-timezone";
import BlockUi from "react-block-ui";
import { CSVLink } from "react-csv";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCloudDownloadAlt } from "@fortawesome/free-solid-svg-icons";
import { MultiSelect } from "react-multi-select-component";
import { v4 as uuidv4 } from 'uuid';
import CallAnalysisSummaryTemplateModal from "./CallAnalysisSummaryElements/CallAnalysisSummaryTemplateModal";
import * as GlobalConst from "../../components/AscConstants";
import CallAnalysisSummaryTemplateCheckModal from "./CallAnalysisSummaryElements/CallAnalysisSummaryTemplateCheckModal";

const SearchMenu = styled.div`
    width: ${(p) => p.width || 0}px;
    height: ${(p) => p.height || 0}px;
    position: fixed;
    right: 0;
    overflow-y: auto;
    justify-content: center;

    transition: 0.5s;
    background-color: ${(p) => p.background || "#eef3f9"};
    box-shadow: 0px 0px 5px 0.1px rgba(172, 173, 168);
    border-radius: 4px;
    z-index: 1;
`;

export default class CallAnalysisSummary extends AscComponent {
    constructor(props) {
        super(props);
        
        this.state = {
            data: [],
            loading: false,
            filtered: [
                {
                    id: "inout_type",
                    value: "all"
                },
                {
                    id: "cm12_id",
                    value: {
                        value: this.props.userInfo.company_id, 
                        label:this.props.userInfo.company_name, 
                        floor_flg: this.props.userInfo.floor_flg ? "Y" : "N"
                    }
                },
                {
                    id: "start_datetime",
                    value: moment().subtract(30, 'days').startOf('day')
                },
                {
                    id: "end_datetime",
                    value: moment().endOf("day")
                },
                {
                    id: "summary_method",
                    value: "average"
                },
                {
                    id: "view_level",
                    value: "CallAnalysisSummaryOverview"
                }
            ],
            hidden_filtered: [
                {
                    id: "inout_type",
                    value: "all"
                },
                {
                    id: "cm12_id",
                    value: {
                        value: this.props.userInfo.company_id, 
                        label:this.props.userInfo.company_name, 
                        floor_flg: this.props.userInfo.floor_flg ? "Y" : "N"
                    }
                },
                {
                    id: "start_datetime",
                    value: moment().subtract(30, 'days').startOf('day')
                },
                {
                    id: "end_datetime",
                    value: moment().endOf("day")
                },
                {
                    id: "summary_method",
                    value: "average"
                },
                {
                    id: "view_level",
                    value: "CallAnalysisSummaryOverview"
                }
            ],
            compare_filtered: [
                {
                    id: "inout_type",
                    value: "all"
                },
                {
                    id: "cm12_id",
                    value: {
                        value: this.props.userInfo.company_id, 
                        label:this.props.userInfo.company_name, 
                        floor_flg: this.props.userInfo.floor_flg ? "Y" : "N"
                    }
                },
                {
                    id: "start_datetime",
                    value: moment().subtract(30, 'days').startOf('day')
                },
                {
                    id: "end_datetime",
                    value: moment().endOf("day")
                },
                {
                    id: "summary_method",
                    value: "average"
                },
                {
                    id: "view_level",
                    value: "CallAnalysisSummaryCompare"
                }
            ],
            compare_hidden_filtered: [
                {
                    id: "inout_type",
                    value: "all"
                },
                {
                    id: "cm12_id",
                    value: {
                        value: this.props.userInfo.company_id, 
                        label:this.props.userInfo.company_name, 
                        floor_flg: this.props.userInfo.floor_flg ? "Y" : "N"
                    }
                },
                {
                    id: "start_datetime",
                    value: moment().subtract(30, 'days').startOf('day')
                },
                {
                    id: "end_datetime",
                    value: moment().endOf("day")
                },
                {
                    id: "summary_method",
                    value: "average"
                },
                {
                    id: "view_level",
                    value: "CallAnalysisSummaryCompare"
                }
            ],
            sorted: {id: "start_datetime", desc: true},
            csvdata: [],
            display_col: this.getSelectOption('call_analysis_summary_col_list', this.props.langText.SelectOption),
            display_col_list: this.getSelectOption('call_analysis_summary_col_list', this.props.langText.SelectOption),
            display_tag: [],
            display_tag_list: [],
            type: "call_analysis_summary",

            // 画面のビュー
            view: null,
            view_level: "CallAnalysisSummaryOverview",
            refresh_key: "",
            summary_base: this.props.langText.SelectOption.SummaryBase[0].value,
            summary_base_label: this.props.langText.SelectOption.SummaryBase[0].label,
            summary_group: this.props.langText.SelectOption.SummaryGroup[0].value,
            summary_group_label: this.props.langText.SelectOption.SummaryGroup[0].label,

            // メニュー
            menu_height: window.innerHeight - 105,
            menu_width: 0,
            menu_flag: false,
            accordion_flag: false,
            compare_accordion_flag: false,

            // モーダル
            show: false,
            modalType: null,
            disableFlg: false,
            templateSelect: [],
            templateSelected: null,
            compareTemplateSelected: null,
            templateName: "",

            summary_period_select: this.getSelectOption('summary_period', this.props.langText.SelectOption),
            summary_period_selected: "previous_30_day",
            compare_summary_period_select: this.getSelectOption('summary_period', this.props.langText.SelectOption),
            compare_summary_period_selected: "previous_30_day",
            weekday_select: this.getSelectOption('weekday', this.props.langText.SelectOption),
            call_result_select: this.getSelectOption('call_result', this.props.langText.SelectOption),
            
            // CT607設定値（応対品質分析設定）
            ct607_settings: {
                score_max: 100,
                seconds_determine_silence: 3,
                seconds_determine_conflict: 1
            },
            extension_number_select: [],
            operator_info_select: [],
            operator_group_select: [],
            external_number_select: [],
            support_memo_select: [],
            company_select: [],
            floorSelect: [],
            compare_extension_number_select: [],
            compare_operator_info_select: [],
            compare_external_number_select: [],
            compare_support_memo_select: [],
            compare_company_select: [],
            csvTitle: "",
            floor_flg: this.props.userInfo.floor_flg ? "Y" : "N",
            call_result_filter_select: [],
            call_result_exclusion_select: [],
            compare_call_result_filter_select: [],
            compare_call_result_exclusion_select: [],
            call_result_filter: [],
            call_result_exclusion: [],
            compare_call_result_filter: [],
            compare_call_result_exclusion: [],
            compare_floor_flg: this.props.userInfo.floor_flg ? "Y" : "N",
            tag_select: [],
            compare_tag_select: [],

            blocking: false,
            menu_blocking: false,
            compare_menu_blocking: false,

            base_headers: [
                {
                    key: "key_as_string",
                    label: this.props.langText.Body.Date, //日付
                },
                {
                    key: "total_call_count.value",
                    label: this.props.langText.Body.TotalCallCnt, //総発着信数
                },
                {
                    key: "total_connection_count.value",
                    label: this.props.langText.Body.TotalCallConnectCount, //接続数（接続率）
                },
                {
                    key: "billsec_le_30_count.value",
                    label: this.props.langText.Body.CallTimeCount_0_30, // 30秒以下件数
                },
                {
                    key: "billsec_30_60_count.value",
                    label: this.props.langText.Body.CallTimeCount_30_60, // 30秒～1分件数
                },
                {
                    key: "billsec_60_180_count.value",
                    label: this.props.langText.Body.CallTimeCount_60_180, // 1分～3分件数
                },
                {
                    key: "billsec_180_300_count.value",
                    label: this.props.langText.Body.CallTimeCount_180_300, // 3分～5分件数
                },
                {
                    key: "billsec_ge_300_count.value",
                    label: this.props.langText.Body.CallTimeCount_300_over, // 5分以上件数
                },
                {
                    key: "total_billsec.value",
                    label: this.props.langText.Body.TotalCallTime, //総通話時間
                },
                {
                    key: "total_score.value",
                    label: this.props.langText.Body.Score, //総合評価
                },
                {
                    key: "billsec.value",
                    label: this.props.langText.Body.TalkingTime, //通話時間
                },
                {
                    key: "silence_count.value",
                    label: this.props.langText.Body.SilenceCount, //無音回数
                },
                {
                    key: "talk_per.value",
                    label: this.props.langText.Body.TalkRate, //OP会話比率
                },
                {
                    key: "talk_conflict_count.value",
                    label: this.props.langText.Body.TalkConflictCount, //重なり回数
                },
                {
                    key: "operator_talk_speed.value",
                    label: this.props.langText.Body.TalkSpeed, //会話速度
                },
                {
                    key: "operator_talk_speed_diff.value",
                    label: this.props.langText.Body.TalkSpeedDifference, //会話速度差
                },
                {
                    key: "rallying_count.value",
                    label: this.props.langText.Body.RallyingCount, //会話の往復回数
                },
                {
                    key: "filler_count.value",
                    label: this.props.langText.Body.FillerCount, //フィラー回数
                },
                {
                    key: "operator_frequency_average.value",
                    label: this.props.langText.Body.Frequency, //基本周波数
                },
                {
                    key: "operator_frequency_average_diff.value",
                    label: this.props.langText.Body.FrequencyDifference, //基本周波数の差
                },
                {
                    key: "operator_accent.value",
                    label: this.props.langText.Body.Accent, //音声のメリハリ
                },
                {
                    key: "operator_accent_diff.value",
                    label: this.props.langText.Body.AccentDifference, //音声のメリハリの差
                }
            ]
            ,
            // グループ開閉状態(子コンポーネントへ渡す)
            collapsedGroups: {}
        }
        this.csvLink = React.createRef();
        this.csvLinkCallResult = React.createRef();
    }
    // グループ行の開閉トグル(子からのコールバック)
    onToggleGroup = (groupKey) => {
        this.setState(prev => ({
            collapsedGroups: {
                ...prev.collapsedGroups,
                [groupKey]: !prev.collapsedGroups[groupKey]
            }
        }));
    }
    
    // 初期設定
    componentDidMount = async () => {
        window.addEventListener('resize', this.resizeHandle);
        let compare_flag = false;
        let reset_flag = true;
        await this.getCt607Settings(this.props.userInfo.company_id); // CT607設定値を取得
        await this.getCompanyInfo();
        await this.getDeaprtmentInfo(compare_flag, reset_flag);
        await this.getOperatorInfo(compare_flag, reset_flag);
        await this.getExternalNumberInfo(compare_flag, reset_flag);
        await this.getCallResultInfo(compare_flag, this.props.userInfo.company_id, reset_flag);

        if (this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.department)) {
            await this.setCommonFloorSelect({departmentIds: this.props.userInfo.parent_department_id});
        }
        
        const template_info_list = await this.getTemplateInfoList(this.state.type);
        const result = await this.getCommonFloorSelect({
            departmentIds: this.props.userInfo.parent_department_id
        });
        await this.setTagsInfoList(this.props.userInfo.company_id, ["tag_select", "compare_tag_select"]);

        this.setState({ 
            templateSelect: template_info_list.data,
            compare_floor_select: result.data, 
            compare_floor_id: result.data,
            display_col : this.state.display_col_list
        });

        await this.getExtensionNumberInfo(compare_flag, reset_flag);
    }

    componentWillUnmount = () => {
        window.removeEventListener('resize', this.resizeHandle);
        let routesApp = document.getElementById('routes-app');
        if (routesApp) routesApp.style.overflowY = '';
    }

    // CT607設定値を取得
    getCt607Settings = async (company_id) => {
        try {
            const response = await this.ascAxios("post", "/Setting/CallHistoryAnalysisSetting/board", {
                company_id: company_id
            });
            
            if (response && response.data && response.data.data) {
                this.setState({
                    ct607_settings: {
                        score_max: (response.data.data.score_max !== undefined && response.data.data.score_max !== null) ? response.data.data.score_max : 100,
                        seconds_determine_silence: (response.data.data.seconds_determine_silence !== undefined && response.data.data.seconds_determine_silence !== null) ? response.data.data.seconds_determine_silence : 3,
                        seconds_determine_conflict: (response.data.data.seconds_determine_conflict !== undefined && response.data.data.seconds_determine_conflict !== null) ? response.data.data.seconds_determine_conflict : 1
                    }
                });
            }
        } catch (error) {
            console.error("CallAnalysisSummary: CT607設定値取得エラー:", error);
            // エラーの場合もデフォルト値を使用
        }
    }

    toggleBlocking() {
        this.setState({blocking: !this.state.blocking});
    }

    resizeHandle = () => {
        let {
            menu_flag,
            view_level
        } = this.state;

        let height = window.innerHeight - 105;
        let width = 0;

        if (menu_flag) {
            if (view_level === "CallAnalysisSummaryCompare") width = 800;
            else width = 400;
        }

        this.setState({
            menu_height: height,
            menu_width: width
        });
    }

    getCompanyInfo = async () => {
        try {
            const result = await this.getCommonCompanySelect(this.reactContainerPath.split("/").filter(Boolean).slice(-1)[0]);
            
            this.setState({
                company_select: result.data,
                compare_company_select: result.data
            });
        } catch (err) {
            console.error(err);
            this.showErrorObjectMesssage(err);
        }
    }

    getDeaprtmentInfo = async (compare_flag, reset_flag) => {
        let container = {
            container: "/CallAnalysisSummary",
            company_id: this.props.userInfo.company_id,
            floor_flg: this.props.userInfo.floor_flg
        };

        if (!compare_flag) await this.setCommonDepartmentSelect(container);

        if (compare_flag || reset_flag) {
            const result = await this.getCommonDepartmentSelect(container);
            this.setState({ 
                compare_department_select: result.data, 
                compare_department_id: result.data
            });
        }
    }

    // 内線番号セレクト用データ取得
    // マルチ選択された department_id / floor_id を考慮し、優先度: floorIds > departmentIds で cm13_id を決定
    // floor_flg === 'Y' かつ フロア未選択時は部署に紐づく全フロアを自動選択
    getExtensionNumberInfo = async (compare_flag, reset_flag) => {
        let set_state = [];
        const company_obj = this.getFilterData("cm12_id", compare_flag);
        const company_id = company_obj ? company_obj.value : 0;
        const floor_flg = company_obj ? company_obj.floor_flg : 'N';
        const departmentIds = this.getFilterData("department_id", compare_flag);
        let floorIds = this.getFilterData("floor_id", compare_flag);
        let cm13_id = null;

        if (company_id === 0) {
            this.setState(compare_flag ? { compare_extension_number_select: set_state } : { extension_number_select: set_state });
            return;
        }

        // floor_flg が 'Y' かつ 拠点選択あり・フロア未選択の場合は全フロアを対象
        if (floor_flg === 'Y' && departmentIds.length && !floorIds.length) {
            floorIds = (compare_flag ? this.state.compare_floor_select : this.state.floorSelect).map(f => f.value);
        }

        if (floorIds.length) cm13_id = floorIds; else if (departmentIds.length) cm13_id = departmentIds;

        try {
            const result = await this.ascAxios('post', `${this.reactContainerPath}/extensionNumberSelect`, {
                company_id,
                cm13_id
            });
            if (Array.isArray(result.data) && result.data.length > 0) set_state = result.data;
            if (!compare_flag) this.setState({ extension_number_select: set_state });
            if (compare_flag || reset_flag) this.setState({ compare_extension_number_select: set_state });
        } catch (err) {
            console.error(err);
            this.showErrorObjectMesssage(err);
        }
    }

    // オペレータ情報セレクト用データ取得（ロジックは内線番号取得と同様）
    getOperatorInfo = async (compare_flag, reset_flag) => {
        let set_state = [];
        const company_obj = this.getFilterData("cm12_id", compare_flag);
        const company_id = company_obj ? company_obj.value : 0;
        const floor_flg = company_obj ? company_obj.floor_flg : 'N';
        const departmentIds = this.getFilterData("department_id", compare_flag);
        let floorIds = this.getFilterData("floor_id", compare_flag);
        let cm13_id = null;

        if (company_id === 0) {
            this.setState(compare_flag ? { compare_operator_info_select: set_state } : { operator_info_select: set_state });
            return;
        }

        if (floor_flg === 'Y' && departmentIds.length && !floorIds.length) {
            floorIds = (compare_flag ? this.state.compare_floor_select : this.state.floorSelect).map(f => f.value);
        }

        if (floorIds.length) cm13_id = floorIds; else if (departmentIds.length) cm13_id = departmentIds;

        try {
            const result = await this.ascAxios('post', `${this.reactContainerPath}/getOperatorNameByCompanyId`, {
                company_id,
                cm13_id
            });
            if (Array.isArray(result.data) && result.data.length > 0) set_state = result.data;
            if (result.data.length > 0) set_state = result.data;

            // グループ取得（必要時のみ使うためここでは状態保存のみ）
            const groups = await this.ascAxios('post', `${this.reactContainerPath}/getOperatorGroupsByCompanyId`, {
                company_id,
                cm13_id
            });
            const groupOptions = groups.data || [];

            if (!compare_flag) this.setState({ operator_info_select: set_state, operator_group_select: groupOptions });
            if (compare_flag || reset_flag) this.setState({ compare_operator_info_select: set_state });
        } catch (err) {
            console.error(err);
            this.showErrorObjectMesssage(err);
        }
    }

    // 外線番号セレクト用データ取得（ロジックは内線番号取得と同様）
    getExternalNumberInfo = async (compare_flag, reset_flag) => {
        let set_state = [];
        const company_obj = this.getFilterData("cm12_id", compare_flag);
        const company_id = company_obj ? company_obj.value : 0;
        const floor_flg = company_obj ? company_obj.floor_flg : 'N';
        const departmentIds = this.getFilterData("department_id", compare_flag);
        let floorIds = this.getFilterData("floor_id", compare_flag);
        let cm13_id = null;
        
        if (company_id === 0) {
            this.setState(
                compare_flag ? {compare_external_number_select: set_state} 
                    : {external_number_select: set_state}
            );
            return;
        }

        if (floor_flg === 'Y' && departmentIds.length && !floorIds.length) {
            floorIds = (compare_flag ? this.state.compare_floor_select : this.state.floorSelect).map(f => f.value);
        }

        if (floorIds.length) cm13_id = floorIds; else if (departmentIds.length) cm13_id = departmentIds;

        try {
            const result = await this.ascAxios('post', `${this.reactContainerPath}/getAllExternalNumberByPermissionAndCompanyId`, {
                company_id,
                cm13_id
            });
            if (Array.isArray(result.data) && result.data.length > 0) set_state = result.data;
            if (!compare_flag) this.setState({ external_number_select: set_state });
            if (compare_flag || reset_flag) this.setState({ compare_external_number_select: set_state });
        } catch (err) {
            console.error(err);
            this.showErrorObjectMesssage(err);
        }
    }

    // コール結果条件取得
    getCallResultInfo = async (compare_flag, company_id, reset_flag) => {
        try {
            const result = await this.ascAxios('post', `${this.reactContainerPath.split("/")[1]}/getCallResultListByCompanyId`, {
                company_id
            });
            let default_select = {
                value: {cm64_id: 0, cm65_id: 0, level: 0, rank_type: 0},
                label: this.props.langText.SelectOption.CallResultUnRegistered
            }
            let body = reset_flag ? {
                call_result_filter_select: [default_select, ...result.data],
                call_result_exclusion_select: [default_select, ...result.data],
                compare_call_result_filter_select: [default_select, ...result.data],
                compare_call_result_exclusion_select: [default_select, ...result.data]
            } : (
                compare_flag ? {
                    compare_call_result_filter_select: [default_select, ...result.data],
                    compare_call_result_exclusion_select: [default_select, ...result.data]
                } : {
                    call_result_filter_select: [default_select, ...result.data],
                    call_result_exclusion_select: [default_select, ...result.data]
                }
            )
            
            

            this.setState(body);
        } catch (err) {
            console.error(err);
            this.showErrorObjectMesssage(err);
        }
    }

    onChangeSummaryBase = (event) => {
        let idx = this.props.langText.SelectOption.SummaryBase.findIndex(row => row.value === event);

        if (idx === -1) return;

        this.setState({
            summary_base: event,
            summary_base_label: this.props.langText.SelectOption.SummaryBase[idx].label
        }, () => {
            if (this.state.view_level === "CallAnalysisSummaryByOperator" || this.state.view_level === "CallAnalysisSummaryByDay" ||
                this.state.view_level === "CallAnalysisSummaryByWeek" || this.state.view_level === "CallAnalysisSummaryByMonth" ||
                this.state.view_level === "CallAnalysisSummaryByExtensionNumber") {
                this.onSummary({id: "start_datetime", desc: true});
            }
        });
    }

    onChangeSummaryGroup = (event) => {
        let idx = this.props.langText.SelectOption.SummaryGroup.findIndex(row => row.value === event);
        let stateBody = {
            summary_group: event,
            summary_group_label: this.props.langText.SelectOption.SummaryGroup[idx].label,
            templateSelected: null
        }
        let filtered = null;

        if (idx === -1) return;
        if (this.state.view_level === "CallAnalysisSummaryByOperator") {
            // グループ切替時はオペレーター/オペレーターグループのフィルターをクリア
            filtered = [...this.state.filtered].filter(row => (row.id !== "operator_selected_id" && row.id !== "operator_groups"));
            stateBody.filtered = filtered;
        }
        this.setState(stateBody, () => {
            if (this.state.view_level === "CallAnalysisSummaryByOperator") {
                this.onSummary({id: "start_datetime", desc: true});
            }
        });
    }

    // ビューモードボタン情報
    getOverviewModeInfo = () => {
        let callAnalysisSummaryOverviewModeList = this.props.langText.Body.CallAnalysisSummaryOverviewModeList;
        
        return (
            <ButtonGroup className="analysis-btn">
                {
                    Object.keys(callAnalysisSummaryOverviewModeList).map((row, index) => (
                        <Button
                            key={"overview" + index}
                            onClick={(e) => {
                                this.onChange(e, "view_level");
                                this.onSummary({id: "start_datetime", desc: true});
                            }}
                            value={row}
                            className = {this.state.view_level === row ? "analysis-btn-focus" : ""}
                        >
                            {callAnalysisSummaryOverviewModeList[row]}
                        </Button>
                    ))
                }
            </ButtonGroup>
        );
    }

    // ビューモードボタン情報
    getViewModeInfo = () => {
        let callAnalysisSummaryViewModeList = this.props.langText.Body.CallAnalysisSummaryViewModeList;
        let summaryBase = this.props.langText.SelectOption.SummaryBase;
        let summaryGroup = this.props.langText.SelectOption.SummaryGroup;

        return (
            <>
                <ButtonGroup className="analysis-btn">
                    {
                        Object.keys(callAnalysisSummaryViewModeList).map((row, index) => (
                            <Button
                                key={index}
                                onClick={(e) => {
                                    this.onChange(e, "view_level");
                                    this.onSummary({id: "start_datetime", desc: true});
                                }}
                                value={row}
                                className = {this.state.view_level === row ? "analysis-btn-focus" : ""}
                            >
                                {callAnalysisSummaryViewModeList[row]}
                            </Button>
                        ))
                    }
                </ButtonGroup>
                <ButtonGroup className="analysis-btn padding-left-10">
                    <DropdownButton
                        as={ButtonGroup}
                        id="view-change"
                        title={this.state.summary_base_label}
                        onSelect={this.onChangeSummaryBase}
                    >
                        {
                            summaryBase.map(row => (
                                <MenuItem eventKey={row.value}>{row.label}</MenuItem>
                            ))
                        }
                    </DropdownButton>
                    <DropdownButton
                        as={ButtonGroup}
                        id="group-change"
                        title={this.state.summary_group_label}
                        onSelect={this.onChangeSummaryGroup}
                    >
                        {
                            summaryGroup
                                .filter(row => row.value !== "group" || this.state.view_level === "CallAnalysisSummaryByOperator")
                                .map(row => (
                                    <MenuItem eventKey={row.value}>{row.label}</MenuItem>
                                ))
                        }
                    </DropdownButton>
                </ButtonGroup>
            </>
        );
    }

    menuHandle = () => {
        this.setState({
            menu_flag: !this.state.menu_flag
        }, () => {
            this.resizeHandle();
        });
    }

    getFilterData = (param, compare_flag) => {
        let my_param_data = null;
        if (compare_flag) my_param_data = this.state.compare_filtered.find(row => row.id === param); 
        else my_param_data = this.state.filtered.find(row => row.id === param);
        return my_param_data ? my_param_data.value : "";
    }

    onChange = (event, param, period_change, compare_flag) => {
        let my_filtered = null;
        if (compare_flag) my_filtered = this.state.compare_filtered;
        else my_filtered = this.state.filtered;

        let target_index = my_filtered.findIndex(row => row.id === param),
            value = "";
        
        if (event) value = event.target ? event.target.value : event;
        if (target_index !== -1) my_filtered.splice(target_index, 1);
        if ((param === "all_support" || param === "all_keyword") && target_index !== -1) value = !value;
        if (param === "call_result_filter" || param === "call_result_exclusion") {
            const compare = "compare_"
            let key = compare_flag ? `${compare}${param}` : param;

            // コール結果ランクが選択されたものに紐づくランクも一緒に選択される
            if (this.state.call_result_filter_select.length !== event.length && this.state[key].length < event.length) {
                let filter_data = event[event.length - 1];
                let associate_data = [];

                switch (filter_data.value.level) {
                    case 0:
                        associate_data = this.state.call_result_filter_select.filter(row => row.value.cm64_id === filter_data.value.cm64_id && row.value.level !== 0);
                        break;
                    case 1:
                        associate_data = this.state.call_result_filter_select.filter(row => 
                            row.value.rank_type === filter_data.value.rank_type && row.value.cm64_id === filter_data.value.cm64_id && row.value.level !== 1
                        );
                        break;
                    default:
                        break;
                }
                
                associate_data.forEach(row => {
                    event.push(row);
                });
                event = [...new Set(event)];
            } else if (this.state[key].length > event.length && event.length !== 0) {
                // コール結果ランクが除外されたものに紐づくランクも一緒に除外される
                let diff = this.state[key].filter(row => event.indexOf(row) === -1);
                let associate_data = null;

                switch (diff[0].value.level) {
                    case 0:
                        associate_data = event.filter(row => row.value.cm64_id !== diff[0].value.cm64_id);
                        break;
                    case 1:
                        associate_data = event.filter(row => 
                            (row.value.rank_type !== diff[0].value.rank_type || row.value.cm64_id !== diff[0].value.cm64_id) &&
                            (row.value.cm64_id !== diff[0].value.cm64_id || row.value.level !== 0)
                        );
                        break;
                    case 2:
                        associate_data = event.filter(row => 
                            (row.value.rank_type !== diff[0].value.rank_type ||
                            row.value.cm64_id !== diff[0].value.cm64_id ||
                            row.value.level !== 1) &&
                            (row.value.cm64_id !== diff[0].value.cm64_id || row.value.level !== 0)
                        );
                        break;
                    default:
                        break;
                }

                event = associate_data ? associate_data : event;
            }

            let call_result_rank_data = [];
            
            event.forEach(row => {
                let call_result_rank = this.state[`${key}_select`].find(item => 
                    item.value.cm64_id === row.value.cm64_id 
                        && item.value.cm65_id === row.value.cm65_id 
                        && item.value.level === row.value.level
                        && item.value.rank_type === row.value.rank_type
                );
                if (call_result_rank) call_result_rank_data.push(call_result_rank);
            });
            event = call_result_rank_data;
            
            value = event;
            this.setState({[key]: event});
        }

        if (value && (!Array.isArray(value) || value.length)) {
            my_filtered.push({
                id: param,
                value
            });
        }

        if ((param === "start_datetime" || param === "end_datetime") && period_change) {
            if (compare_flag) this.setState({ compare_summary_period_selected: "custom" });
            else this.setState({ summary_period_selected: "custom" });
        } else if (param === "view_level") {
            let temp_menu_width = value === "CallAnalysisSummaryCompare" ? 800 : 400;
            let stateUpdate = {
                view_level: value,
                sorted: {id: "start_datetime", desc: true},
                menu_width: this.state.menu_flag ? temp_menu_width : 0
            };
            // OP+グループから他の集計へ移動する場合は、summary_groupを個別にリセット
            if (this.state.summary_group === "group" && value !== "CallAnalysisSummaryByOperator") {
                stateUpdate.summary_group = "single";
                stateUpdate.summary_group_label = this.props.langText.SelectOption.SummaryGroup.find(s => s.value === "single").label;
                // フィルター上のoperator_groups(グループ)は削除し、operator_selected_id(個別)を使う前提に揃える
                let idx_group = my_filtered.findIndex(row => row.id === "operator_groups");
                if (idx_group !== -1) my_filtered.splice(idx_group, 1);
            }
            this.setState(stateUpdate);
			// ビューレベルがオペレーターかつ集計グループがgroupのとき、
			// オペレーター/オペレーターグループのフィルターをクリア
			if (value === "CallAnalysisSummaryByOperator" && this.state.summary_group === "group") {
				let operator_index = my_filtered.findIndex(row => row.id === "operator_selected_id");
				if (operator_index !== -1) my_filtered.splice(operator_index, 1);
				let group_index = my_filtered.findIndex(row => row.id === "operator_groups");
				if (group_index !== -1) my_filtered.splice(group_index, 1);
			}
        }

        if (param === "cm12_id") {
            let operator_index = my_filtered.findIndex(row => row.id === "operator_selected_id");
            if (operator_index !== -1) my_filtered.splice(operator_index, 1);

            let extension_index = my_filtered.findIndex(row => row.id === "extension_number_selected");
            if (extension_index !== -1) my_filtered.splice(extension_index, 1);

            let external_index = my_filtered.findIndex(row => row.id === "external_number");
            if (external_index !== -1) my_filtered.splice(external_index, 1);

            let department_index = my_filtered.findIndex(row => row.id === "department_id");
            if(department_index !== -1) my_filtered.splice(department_index, 1);

            let floor_index = my_filtered.findIndex(row => row.id === "floor_id");
            if(floor_index !== -1) my_filtered.splice(floor_index, 1);

            let call_result_filter_index = my_filtered.findIndex(row => row.id === "call_result_filter");
            if (call_result_filter_index !== -1) my_filtered.splice(call_result_filter_index, 1);
            
            let call_result_exclusion_index = my_filtered.findIndex(row => row.id === "call_result_exclusion");
            if (call_result_exclusion_index !== -1) my_filtered.splice(call_result_exclusion_index, 1);
        
            let tags_index = my_filtered.findIndex(row => row.id === "tags");
            if (tags_index !== -1) my_filtered.splice(tags_index, 1);
        }

        if (param === "department_id") {
            let floor_index = my_filtered.findIndex(row => row.id === "floor_id");
            if(floor_index !== -1) my_filtered.splice(floor_index, 1);

            let extension_index = my_filtered.findIndex(row => row.id === "extension_number_selected");
            if (extension_index !== -1) my_filtered.splice(extension_index, 1);

            let operator_index = my_filtered.findIndex(row => row.id === "operator_selected_id");
            if (operator_index !== -1) my_filtered.splice(operator_index, 1);

            let external_index = my_filtered.findIndex(row => row.id === "external_number");
            if (external_index !== -1) my_filtered.splice(external_index, 1);
        }

        if (param === "floor_id") {
            let operator_index = my_filtered.findIndex(row => row.id === "operator_selected_id");
            if (operator_index !== -1) my_filtered.splice(operator_index, 1);

            let extension_index = my_filtered.findIndex(row => row.id === "extension_number_selected");
            if (extension_index !== -1) my_filtered.splice(extension_index, 1);

            let external_index = my_filtered.findIndex(row => row.id === "external_number");
            if (external_index !== -1) my_filtered.splice(external_index, 1);
        }

        let returnValue = [];

        returnValue = my_filtered;

        // テンプレート選択でフィルターのコール結果・ランク関連が変更される時はフィルターのみ変更
        // その他の場合はフィルター変更かつテンプレート初期化
        let stateBody = null;
        if (compare_flag) {
            if ((param !== "call_result_filter" && param !== "call_result_exclusion") || !period_change) {
                stateBody = { compare_filtered: returnValue, compareTemplateSelected: null };
            } else {
                stateBody = { compare_filtered: returnValue };
            }
        } else {
            if ((param !== "call_result_filter" && param !== "call_result_exclusion") || !period_change) {
                stateBody = { filtered: returnValue, templateSelected: null };
            }
            else {
                stateBody = { filtered: returnValue };
            }
        }

        this.setState(stateBody);
    }

    onTimeChange = (event, param, compare_flag, template_flag=false) => {
        let max = 100;
        let value = event ? event.target.value : "";
        value = value.replace(/[^0-9]+/i, "");

        if (value !== "") {
            if (value.length > 1 && value.charAt(0) === "0") value = value.substr(1);
            Number(value);
        }
        switch (param) {
            case "start_ji":
            case "end_ji":
                max = 23;
                break;
            case "start_hun":
            case "call_start_hun":
            case "call_start_byo":
            case "end_hun":
            case "call_end_hun":
            case "call_end_byo":
                max = 59;
                break;
            default:
                break;
        }

        if (value > max && param !== "ct60_id") return;

        if (!template_flag) this.onChange(value, param, false, compare_flag);
        else this.setState({[param]: value});
    }

    onSelectChange = async (event, param, compare_flag, template_filtered=null) => {
        if (param !== "templateSelected") super.onSelectChange(event, param);

        let value = (event && event.value) ? event.value : "";

        switch (param) {
            case "summary_period_selected":
            case "compare_summary_period_selected":
                this.onPeriodChange(value, compare_flag);
                break;
            case "cm12_id":
                this.onChange(event, param, false, compare_flag);
                if(event && param !== null){
                    if (compare_flag) {
                        await this.getCallResultInfo(compare_flag, value);
                        await this.setTagsInfoList(value, ["compare_tag_select"]);
                        const result = await this.getCommonDepartmentSelect({
                            container: "/CallAnalysisSummary",
                            company_id: value,
                            floor_flg: event.floor_flg === "Y" ? "Y" : null
                        });
                        this.setState({ 
                            compare_department_select: result.data, 
                            compare_floor_flg: event.floor_flg,
                            compare_call_result_filter: [],
                            compare_call_result_exclusion: [],
                        }, () => {
                            if (template_filtered) {
                                let call_result_filter = template_filtered.find(row => row.id === "call_result_filter");
                                let call_result_exclusion = template_filtered.find(row => row.id === "call_result_exclusion");
                            
                                if (call_result_filter) this.onChange(call_result_filter.value, "call_result_filter", true, compare_flag);
                                if (call_result_exclusion) this.onChange(call_result_exclusion.value, "call_result_exclusion", true, compare_flag);
                                
                                let blocking = compare_flag ? "compare_menu_blocking" : "menu_blocking";
                                this.setState({ [blocking]: false });
                            }
                        });
                    } else {
                        await this.getCallResultInfo(compare_flag, value);
                        await this.setCommonDepartmentSelect({
                            container: "/CallAnalysisSummary",
                            company_id: value,
                            floor_flg: event.floor_flg === "Y" ? "Y" : null
                        });
                        await this.setTagsInfoList(value, ["tag_select"]);

                        this.setState({
                            floor_flg: event.floor_flg,
                            call_result_filter: [],
                            call_result_exclusion: [],
                        }, () => {
                            if (template_filtered) {
                                let call_result_filter = template_filtered.find(row => row.id === "call_result_filter");
                                let call_result_exclusion = template_filtered.find(row => row.id === "call_result_exclusion");
                            
                                if (call_result_filter) this.onChange(call_result_filter.value, "call_result_filter", true, compare_flag);
                                if (call_result_exclusion) this.onChange(call_result_exclusion.value, "call_result_exclusion", true, compare_flag);
                            
                                let blocking = compare_flag ? "compare_menu_blocking" : "menu_blocking";
                                this.setState({ [blocking]: false });
                            }
                        });
                    }
                } else {
                    this.setState(
                        compare_flag ? { 
                                compare_tag_select: [],
                                compare_department_select: [], 
                                compare_floor_select: [], 
                                compare_call_result_filter: [],
                                compare_call_result_exclusion: [],
                                compare_call_result_filter_select: [],
                                compare_call_result_exclusion_select: []
                            } 
                            : {
                                tag_select: [],
                                departmentSelect: [],
                                floorSelect: [],
                                call_result_filter: [],
                                call_result_exclusion: [],
                                call_result_filter_select: [],
                                call_result_exclusion_select: []
                            }
                    );
                }
                await this.getExtensionNumberInfo(compare_flag);
                await this.getOperatorInfo(compare_flag);
                await this.getExternalNumberInfo(compare_flag);
                break;
            case "start_datetime":
            case "start_ji":
            case "start_hun":
            case "end_datetime":
            case "end_ji":
            case "end_hun":
            case "periodSetting":
                this.setState({[param]: event});
                break;
            case "templateSelected":
                if (event) {
                    let template_filtered = event.template_json.filtered.map(row => Object.assign({}, row));
                    let period = event.template_json.period;
                    let blocking = compare_flag ? "compare_menu_blocking" : "menu_blocking";
                    let call_result_flag = this.checkCallResultInTemplateToFilter(template_filtered, this.state.filtered);
                    
                    // フィルターにテンプレートを適用する時、コール結果関連が変更する場合実行かつoem管理者以上(コール結果は会社単位なので)
                    if (call_result_flag && this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) this.setState({ [blocking]: true });

                    // 文字から検索フィルターに変更
                    for (let i = 0; i < template_filtered.length; i++) {
                        if (template_filtered[i].id === "cm12_id" && this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
                            await this.onSelectChange(template_filtered[i].value, template_filtered[i].id, compare_flag, template_filtered);
                        }
                        if (template_filtered[i].id === "department_id" && this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)) {
                            await this.onMultiSelectChange(template_filtered[i].value, template_filtered[i].id, compare_flag, template_filtered);
                        }
                        if (template_filtered[i].id === "floor_id" && this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.department)) {
                            await this.onMultiSelectChange(template_filtered[i].value, template_filtered[i].id, compare_flag, template_filtered);
                        }
                        if (template_filtered[i].id === "start_datetime" || template_filtered[i].id === "end_datetime") {
                            if (period.value === "custom") {
                                template_filtered[i].value = moment.tz(template_filtered[i].value, "Asia/Tokyo");
                            } else {
                                let datetime = this.onPeriodChange(period.value, compare_flag, true);
                                template_filtered[i].value = datetime[template_filtered[i].id];
                            }
                        }
                        if (template_filtered[i].id === "call_result_filter" && this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.company)) {
                            this.onChange(template_filtered[i].value, "call_result_filter", true, compare_flag);
                        } 
                        if (template_filtered[i].id === "call_result_exclusion"  && this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.company)) {
                            this.onChange(template_filtered[i].value, "call_result_exclusion", true, compare_flag);
                        }
                        if (template_filtered[i].id === "tags") {
                            template_filtered[i].value = template_filtered[i].value.map(row => {
                                return {
                                    ...row,
                                    label: (
                                        <span
                                            style={row.label.props.style}
                                        >
                                            {row.label.props.children}
                                        </span>
                                    )
                                };
                            });
                        }
                        if (template_filtered[i].id === "view_level") {
                            template_filtered[i].value = this.state.view_level;
                        }
                        if (this.state.summary_group === "group" && template_filtered[i].id === "operator_selected_id") {
                            const idx = template_filtered.findIndex(row => row.id === "operator_selected_id");
                            if (idx !== -1) template_filtered.splice(idx, 1);
                        } else if (this.state.summary_group === "single" && template_filtered[i].id === "operator_groups") {
                            const idx = template_filtered.findIndex(row => row.id === "operator_groups");;
                            if (idx !== -1) template_filtered.splice(idx, 1);
                        }
                    }

                    // テンプレート適用時、現在のセレクトリストに存在しない値を除外する
                    this.filterTemplateBySelectOptions(template_filtered, compare_flag);
                    
                    if (compare_flag) {
                        this.setState({
                            compare_filtered: template_filtered,
                            compare_hidden_filtered: template_filtered,
                            compare_summary_period_selected: period.value
                        });
                    } else {
                        this.setState({
                            filtered: template_filtered,
                            hidden_filtered: template_filtered,
                            summary_period_selected: period.value
                        });
                    }
                }
                if (compare_flag) this.setState({ compareTemplateSelected: event });
                else this.setState({ [param]: event });

                break;
            default:
                break;
        }
    }

    // テンプレート適用時、現在のセレクトリストに存在しない値をtemplate_filteredから除外する
    filterTemplateBySelectOptions = (template_filtered, compare_flag) => {
        if (!template_filtered) return;

        // 会社（単一選択）のフィルタリング
        const companySelect = compare_flag ? this.state.compare_company_select : this.state.company_select;
        if (companySelect && companySelect.length > 0) {
            template_filtered.forEach(item => {
                if (item.id === "cm12_id" && item.value && typeof item.value === "object") {
                    const found = companySelect.some(s => s.value === item.value.value);
                    if (!found) {
                        item.value = null;
                    }
                }
            });
        }

        // 配列セレクトのフィルタリング
        const selectMap = {
            "department_id": compare_flag ? this.state.compare_department_select : this.state.departmentSelect,
            "floor_id": compare_flag ? this.state.compare_floor_select : this.state.floorSelect,
            "external_number": compare_flag ? this.state.compare_external_number_select : this.state.external_number_select,
            "extension_number_selected": compare_flag ? this.state.compare_extension_number_select : this.state.extension_number_select,
            "operator_selected_id": compare_flag ? this.state.compare_operator_info_select : this.state.operator_info_select,
            "operator_groups": this.state.operator_group_select,
        };

        template_filtered.forEach(item => {
            const selectOptions = selectMap[item.id];
            if (selectOptions && Array.isArray(item.value)) {
                item.value = item.value.filter(v => {
                    const val = typeof v === "object" ? v.value : v;
                    return selectOptions.some(s => s.value === val);
                });
            }
        });

        // 通話分類タグのフィルタリング
        const tagSelect = compare_flag ? this.state.compare_tag_select : this.state.tag_select;
        if (tagSelect && tagSelect.length > 0) {
            template_filtered.forEach(item => {
                if (item.id === "tags" && Array.isArray(item.value)) {
                    item.value = item.value.filter(tag => {
                        return tagSelect.some(s => s.value === tag.value);
                    });
                }
            });
        }

        // コール結果絞り込み/除外のフィルタリング（オブジェクト比較）
        const callResultIds = ["call_result_filter", "call_result_exclusion"];
        const callResultSelectMap = {
            "call_result_filter": compare_flag ? this.state.compare_call_result_filter_select : this.state.call_result_filter_select,
            "call_result_exclusion": compare_flag ? this.state.compare_call_result_exclusion_select : this.state.call_result_exclusion_select,
        };

        template_filtered.forEach(item => {
            if (callResultIds.includes(item.id) && Array.isArray(item.value)) {
                const selectOptions = callResultSelectMap[item.id];
                if (selectOptions && selectOptions.length > 0) {
                    item.value = item.value.filter(row => {
                        return selectOptions.some(s =>
                            s.value.cm64_id === row.value.cm64_id
                            && s.value.cm65_id === row.value.cm65_id
                            && s.value.level === row.value.level
                            && s.value.rank_type === row.value.rank_type
                        );
                    });
                }
            }
        });

        // フィルタリング後に値が空（null・空配列）になった項目を除去する
        for (let i = template_filtered.length - 1; i >= 0; i--) {
            const val = template_filtered[i].value;
            if (val === null || val === undefined || (Array.isArray(val) && val.length === 0)) {
                template_filtered.splice(i, 1);
            }
        }
    }

    // マルチセレクト変更時の共通ハンドラ
    // ・tags はオブジェクト配列保持
    // ・その他は ID 配列に変換してフィルターへ保存
    // ・拠点/フロア変更時は関連セレクトを並列再取得
    onMultiSelectChange = async (event, param, compare_flag, template_flag=false) => {
        super.onMultiSelectChange(event, param);
        let value_arr = (event && event.length) ? (param === 'tags' ? event : event.map(r => r.value)) : [];
        
        switch (param) {
            case 'tags':
            case 'operator_groups':
                value_arr = event;
                break;
        
            default:
                event.forEach((row, index) => {
                    value_arr[index] = row['value'];
                });
                break;
        }

        if (template_flag) {
            value_arr = event;

            // テンプレート適用時、依存データ取得（内線/OP/外線）で正しいフィルターが使われるよう
            // filtered 配列に拠点/フロアの値を直接追加する（onChangeの副作用を避ける）
            if (param === 'department_id' || param === 'floor_id') {
                let my_filtered = compare_flag ? this.state.compare_filtered : this.state.filtered;
                let target_index = my_filtered.findIndex(row => row.id === param);
                if (target_index !== -1) my_filtered.splice(target_index, 1);
                if (value_arr && (!Array.isArray(value_arr) || value_arr.length)) {
                    my_filtered.push({ id: param, value: value_arr });
                }
            }
        }

        // フィルター状態更新（プリミティブID配列またはタグオブジェクト配列を一度だけ保存）
        if (!template_flag) this.onChange(value_arr, param, false, compare_flag);

        switch (param) {
            case 'department_id': // 拠点選択変更
                if (event && event.length) {
                    if (compare_flag) {
                        const result = await this.getCommonFloorSelect({ departmentIds: value_arr });
                        this.setState({ compare_floor_select: result.data });
                    } else {
                        await this.setCommonFloorSelect({ departmentIds: value_arr });
                    }
                } else {
                    this.setState({ floorSelect: [] });
                }
                // 依存するセレクト（内線/オペレータ/外線）を並列取得
                await Promise.all([ 
                    this.getExtensionNumberInfo(compare_flag),
                    this.getOperatorInfo(compare_flag),
                    this.getExternalNumberInfo(compare_flag)
                ]);
                // テンプレート適用時、現在のセレクトリストに存在しない値を除外する
                if (template_flag) {
                    this.filterTemplateBySelectOptions(template_flag, compare_flag);
                }
                break;
            case 'floor_id': // フロア選択変更
                await Promise.all([
                    this.getExtensionNumberInfo(compare_flag),
                    this.getOperatorInfo(compare_flag),
                    this.getExternalNumberInfo(compare_flag)
                ]);
                // テンプレート適用時、現在のセレクトリストに存在しない値を除外する
                if (template_flag) {
                    this.filterTemplateBySelectOptions(template_flag, compare_flag);
                }
                break;
            default:
                break;
        }
    }

    onPeriodChange = (value, compare_flag, template_change) => {
        if (value === "custom") return;
        
        let start_datetime = moment().startOf("day");
        let end_datetime = moment().endOf("day");

        switch (value) {
            case "yesterday":
                start_datetime = moment().subtract(1, "days").startOf("day");
                end_datetime = moment().subtract(1, "days").endOf("day");
                break;
            case "this_week":
                start_datetime = moment().startOf("week");
                end_datetime = moment().endOf("week");
                break;
            case "last_week":
                start_datetime = moment().subtract(1, "week").startOf("week");
                end_datetime = moment().subtract(1, "week").endOf("week");
                break;
            case "previous_2_week":
                start_datetime = moment().subtract(2, "week").startOf("week");
                end_datetime = moment().subtract(2, "week").endOf("week");
                break;
            case "previous_3_week":
                start_datetime = moment().subtract(3, "week").startOf("week");
                end_datetime = moment().subtract(3, "week").endOf("week");
                break;
            case "previous_4_week":
                start_datetime = moment().subtract(4, "week").startOf("week");
                end_datetime = moment().subtract(4, "week").endOf("week");
                break;
            case "previous_5_week":
                start_datetime = moment().subtract(5, "week").startOf("week");
                end_datetime = moment().subtract(5, "week").endOf("week");
                break;
            case "previous_6_week":
                start_datetime = moment().subtract(6, "week").startOf("week");
                end_datetime = moment().subtract(6, "week").endOf("week");
                break;
            case "previous_30_day":
                start_datetime = moment().subtract(30, 'days').startOf('day');
                break;
            case "this_month":
                start_datetime = moment().startOf('month');
                end_datetime = moment().endOf('month');
                break;
            case "last_month":
                start_datetime = moment().subtract(1, 'month').startOf('month');
                end_datetime = moment().subtract(1, 'month').endOf('month');
                break;
            case "previous_2_month":
                start_datetime = moment().subtract(2, 'months').startOf('month');
                end_datetime = moment().subtract(2, 'months').endOf('month');
                break;
            case "previous_3_month":
                start_datetime = moment().subtract(3, 'months').startOf('month');
                end_datetime = moment().subtract(3, 'months').endOf('month');
                break;
            case "now_quarter":
                start_datetime = moment().startOf('quarter');
                end_datetime = moment().endOf('quarter');
                break;
            case "previous_quarter":
                start_datetime = moment().subtract(1, 'quarter').startOf('quarter');
                end_datetime = moment().subtract(1, 'quarter').endOf('quarter');
                break;
            default:
                break;
        }

        if (template_change) {
            return {start_datetime, end_datetime};
        } else {
            this.onChange(start_datetime, "start_datetime", false, compare_flag);
            this.onChange(end_datetime, "end_datetime", false, compare_flag);
        }
    }

    onClickAccordion = (event, compare_flag) => {
        if (compare_flag) this.setState({ compare_accordion_flag: !this.state.compare_accordion_flag });
        else this.setState({ accordion_flag: !this.state.accordion_flag });
    }

    validationHandle = (param, compare_flag) => {
        let nowState = true,
            start_ji = this.getFilterData("start_ji", compare_flag) ? Number(this.getFilterData("start_ji", compare_flag)) : "",
            start_hun = this.getFilterData("start_hun", compare_flag) ? Number(this.getFilterData("start_hun", compare_flag)) : "",
            end_ji = this.getFilterData("end_ji", compare_flag) ? Number(this.getFilterData("end_ji", compare_flag)) : "",
            end_hun = this.getFilterData("end_hun", compare_flag) ? Number(this.getFilterData("end_hun", compare_flag)) : "",
            call_start_hun = this.getFilterData("call_start_hun", compare_flag) ? Number(this.getFilterData("call_start_hun", compare_flag)) : "",
            call_start_byo = this.getFilterData("call_start_byo", compare_flag) ? Number(this.getFilterData("call_start_byo", compare_flag)) : "",
            call_end_hun = this.getFilterData("call_end_hun", compare_flag) ? Number(this.getFilterData("call_end_hun", compare_flag)) : "",
            call_end_byo = this.getFilterData("call_end_byo", compare_flag) ? Number(this.getFilterData("call_end_byo", compare_flag)) : "",
            min_score = this.getFilterData("min_score", compare_flag) ? Number(this.getFilterData("min_score", compare_flag)) : "",
            max_score = this.getFilterData("max_score", compare_flag) ? Number(this.getFilterData("max_score", compare_flag)) : "",
            min_talk_rate = this.getFilterData("min_talk_rate", compare_flag) ? Number(this.getFilterData("min_talk_rate", compare_flag)) : "",
            max_talk_rate = this.getFilterData("max_talk_rate", compare_flag) ? Number(this.getFilterData("max_talk_rate", compare_flag)) : "",
            min_speech_speed = this.getFilterData("min_speech_speed", compare_flag) ? Number(this.getFilterData("min_speech_speed", compare_flag)) : "",
            max_speech_speed = this.getFilterData("max_speech_speed", compare_flag) ? Number(this.getFilterData("max_speech_speed", compare_flag)) : "",
            template_start_ji = this.state.start_ji ? Number(this.state.start_ji) : "",
            template_start_hun = this.state.start_hun ? Number(this.state.start_hun) : "",
            template_end_ji = this.state.end_ji ? Number(this.state.end_ji) : "",
            template_end_hun = this.state.end_hun ? Number(this.state.end_hun) : "";
        let {
            templateName
        } = this.state;
        
        switch(param) {
            case "start_ji":
            case "end_ji":
            case "start_hun":
            case "end_hun":
                nowState = !(
                    (start_ji && (end_ji || end_ji === 0)) &&
                    (start_ji > end_ji)
                );
            
                nowState = nowState ? 
                    !(
                        (((start_ji && end_ji) && (start_ji === end_ji)) || (!start_ji && !end_ji)) &&
                        (start_hun && (end_hun || end_hun === 0)) &&
                        (start_hun > end_hun)
                    ) : false;
                break;
            case "call_start_hun":
            case "call_end_hun":
            case "call_start_byo":
            case "call_end_byo":
                nowState = !(
                    (call_start_hun && (call_end_hun || call_end_hun === 0)) &&
                    (call_start_hun > call_end_hun)
                );
                
                nowState = nowState ? 
                    !(
                        (((call_start_hun && call_end_hun) && (call_start_hun === call_end_hun)) || (!call_start_hun && !call_end_hun)) &&
                        (call_start_byo && (call_end_byo || call_end_byo === 0)) &&
                        (call_start_byo > call_end_byo)
                    ) : false;
                break;
            case "min_score":
            case "max_score":
                nowState = !(
                    (min_score && (max_score || max_score === 0)) &&
                    (min_score > max_score)
                );
                break;
            case "min_talk_rate":
            case "max_talk_rate":    
                nowState = !(
                    (min_talk_rate && (max_talk_rate || max_talk_rate === 0)) &&
                    (min_talk_rate > max_talk_rate)
                );
                break;
            case "min_speech_speed":
            case "max_speech_speed":
                nowState = !(
                    (min_speech_speed && (max_speech_speed || max_speech_speed === 0)) &&
                    (min_speech_speed > max_speech_speed)
                );
                break;
            case "summary":
            case "template":
                nowState = !(
                    ((start_ji && (end_ji || end_ji === 0)) && (start_ji > end_ji)) ||
                    (
                        (((start_ji && end_ji) && (start_ji === end_ji)) || (!start_ji && !end_ji)) &&
                        (start_hun && (end_hun || end_hun === 0)) &&
                        (start_hun > end_hun)
                    ) ||
                    ((call_start_hun && (call_end_hun || call_end_hun === 0)) && (call_start_hun > call_end_hun)) ||
                    (
                        (((call_start_hun && call_end_hun) && (call_start_hun === call_end_hun)) || (!call_start_hun && !call_end_hun)) &&
                        (call_start_byo && (call_end_byo || call_end_byo === 0)) &&
                        (call_start_byo > call_end_byo)
                    ) ||
                    ((min_score && (max_score || max_score === 0)) && (min_score > max_score)) ||
                    ((min_talk_rate && (max_talk_rate || max_talk_rate === 0)) && (min_talk_rate > max_talk_rate)) ||
                    ((min_speech_speed && (max_speech_speed || max_speech_speed === 0)) && (min_speech_speed > max_speech_speed)) ||
                    (compare_flag && !this.validationHandle(param))
                );
                break;
            case "templateName":
                nowState = this.state[param] ? null : 'error';
                break;
            case "template_start_ji":
            case "template_start_hun":
            case "template_end_ji":
            case "template_end_hun":
            case "time":
                nowState = !(
                    (template_start_ji && (template_end_ji || template_end_ji === 0)) &&
                    (template_start_ji > template_end_ji)
                );
            
                nowState = nowState ? 
                    !(
                        (((template_start_ji && template_end_ji) && (template_start_ji === template_end_ji)) 
                            || (!template_start_ji && !template_end_ji)) &&
                        (template_start_hun && (template_end_hun || template_end_hun === 0)) &&
                        (template_start_hun > template_end_hun)
                    ) : false;
                break;
            case "templateInsert":
            case "templateCopy":
            case "templateUpdate":
                let timeValidation = !(
                    (template_start_ji && (template_end_ji || template_end_ji === 0)) &&
                    (template_start_ji > template_end_ji)
                );
            
                timeValidation = timeValidation ? 
                    !(
                        (((template_start_ji && template_end_ji) && (template_start_ji === template_end_ji)) 
                            || (!template_start_ji && !template_end_ji)) &&
                        (template_start_hun && (template_end_hun || template_end_hun === 0)) &&
                        (template_start_hun > template_end_hun)
                    ) : false;

                nowState = (
                    templateName && timeValidation
                );
                break;
            default:
                break;
        }

        return nowState;
    }

    onClear = async () => {
        let filter = [...this.state.filtered];
        let view_level = filter.find(row => row.id === "view_level").value;

        let my_filtered = [
            {
                id: "inout_type",
                value: "all"
            },
            {
                id: "cm12_id",
                value: {
                    value: this.props.userInfo.company_id, 
                    label:this.props.userInfo.company_name, 
                    floor_flg: this.props.userInfo.floor_flg ? "Y" : "N"
                }
            },
            {
                id: "start_datetime",
                value: moment().subtract(30, 'days').startOf('day')
            },
            {
                id: "end_datetime",
                value: moment().endOf("day")
            },
            {
                id: "summary_method",
                value: "average"
            },
            {
                id: "view_level",
                value: view_level
            }
        ];

        let compare_filtered = [
            {
                id: "inout_type",
                value: "all"
            },
            {
                id: "cm12_id",
                value: {
                    value: this.props.userInfo.company_id, 
                    label:this.props.userInfo.company_name, 
                    floor_flg: this.props.userInfo.floor_flg ? "Y" : "N"
                }
            },
            {
                id: "start_datetime",
                value: moment().subtract(30, 'days').startOf('day')
            },
            {
                id: "end_datetime",
                value: moment().endOf("day")
            },
            {
                id: "summary_method",
                value: "average"
            },
            {
                id: "view_level",
                value: "CallAnalysisSummaryCompare"
            }
        ];

        // 会社管理者以上の場合はリストもクリア、拠点管理者以下の場合は選択のみクリア
        let floorClearState = this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.company)
            ? { floorSelect: [], compare_floor_select: [] }  // リストもクリア
            : {};  // リストはクリアしない

        this.setState({
            filtered: my_filtered,
            summary_period_selected: "previous_30_day",
            compare_filtered,
            compare_summary_period_selected: "previous_30_day",
            call_result_filter: [],
            call_result_exclusion: [],
            compare_call_result_filter: [],
            compare_call_result_exclusion: [],
            templateSelected: null,
            compareTemplateSelected: null,
            ...floorClearState  // フロアリストのクリア（会社管理者以上の場合のみ）
        }, async () => {
            await this.getCompanyInfo();
            let compare_flag = false;
            let reset_flag = true;
            await this.getCt607Settings(this.props.userInfo.company_id);
            await this.getDeaprtmentInfo(compare_flag, reset_flag);
            await this.getOperatorInfo(compare_flag, reset_flag);
            await this.getExternalNumberInfo(compare_flag, reset_flag);
            await this.getCallResultInfo(compare_flag, this.props.userInfo.company_id, reset_flag);
            await this.setTagsInfoList(this.props.userInfo.company_id, ["tag_select", "compare_tag_select"]);

            this.setState({ 
                floor_flg: this.props.userInfo.floor_flg ? "Y" : "N", 
                compare_floor_flg: this.props.userInfo.floor_flg ? "Y" : "N"
            });
            await this.getExtensionNumberInfo(compare_flag, reset_flag);
        });
    }

    onSummary = async (sort) => {
        let {
            filtered,
            compare_filtered,
            sorted,
            summary_base
        } = this.state;
        let compare_filter = [];
        let randomId = ""; 

        this.setState({
            loading: true
        });
        let routesApp = document.getElementById('routes-app');
        if (routesApp) {
            routesApp.scrollTop = 0;
            routesApp.style.overflowY = 'hidden';
        }
        
        let filter = [...filtered];
        
        // 現在選択されている会社のCT607設定を取得
        let company_data = filter.find(row => row.id === "cm12_id");
        if (company_data && company_data.value && company_data.value.value) {
            await this.getCt607Settings(company_data.value.value);
        }
        let view_level = filter.find(row => row.id === "view_level").value;

        let set_state_obj = {
            hidden_filtered: filter
        }

        if (view_level === "CallAnalysisSummaryCompare") {
            compare_filter = [...compare_filtered];
            set_state_obj.compare_hidden_filtered = compare_filter;
        }

        if (sort) {
            sorted = sort;
        }

        try {
            // setStateをPromiseでラップして完了を待つ
            // ボタン無効化フラグを保持したまま待機
            await new Promise(resolve => this.setState(set_state_obj, resolve));
            
            let result = "";
            let display_tag = [];
            filter = this.state.hidden_filtered;
            compare_filter = this.state.compare_hidden_filtered;
            let summary_group = this.state.summary_group;
            let count_msg_flag = false;

            switch (view_level) {
                case "CallAnalysisSummaryOverview":
                    // 全体集計は通話履歴ID指定がないのでフィルターからct60_idを削除
                    filter = filter.filter(row => row.id !== "ct60_id");
                    // 全体集計はグループ集計がないのでフィルターからoperator_groupsを削除
                    filter = filter.filter(row => row.id !== "operator_groups");
                    result = await this.ascAxios('post', `${this.reactContainerPath}/overview`, {
                        filtered: filter,
                        compare_flag: false,
                    });
                    break;
                case "CallAnalysisSummaryByExtensionNumber":
                case "CallAnalysisSummaryByOperator":
                case "CallAnalysisSummaryByDay":
                case "CallAnalysisSummaryByWeek":
                case "CallAnalysisSummaryByMonth":
                    let filtered_idx = this.state.hidden_filtered.findIndex(row => row.id === "cm12_id");
                    let company_id = filtered_idx !== -1 ? this.state.filtered[filtered_idx].value.value : null;
                    display_tag = await this.getTagsInfoList(company_id);
                    // 項目別集計は通話履歴ID指定がないのでフィルターからct60_idを削除
                    filter = filter.filter(row => row.id !== "ct60_id");
                    if (view_level === "CallAnalysisSummaryByOperator" && summary_group === "group") {
                        // グループ集計かつOP別は個別オペレーターを使わないのでフィルターからoperator_selected_idを削除
                        filter = filter.filter(row => row.id !== "operator_selected_id");
                    } else {
                        // グループ集計かつOP別じゃなければグループ集計じゃないのでフィルターからoperator_groupsを削除
                        filter = filter.filter(row => row.id !== "operator_groups");
                    }

                    result = await this.ascAxios('post', `${this.reactContainerPath}/summary`, {
                        filtered: filter,
                        sorted,
                        summary_base,
                        display_tag,
                        // サマリーグループ情報を送信（オペレーター時のみ使用）
                        summary_group: this.state.summary_group
                    });
                    randomId = uuidv4(); //共用コンポーネント(Summaries.js)を更新するためランダムIDを取得
                    
                    // データ漏れがあるか確認
                    count_msg_flag = result.data && result.data[0] && result.data[0].count_msg_flag 
                        ? result.data[0].count_msg_flag 
                        : false;
                    break;
                case "CallAnalysisSummaryCompare":
                    // 比較集計はグループ集計がないのでフィルターからoperator_groupsを削除
                    filter = filter.filter(row => row.id !== "operator_groups");
                    compare_filter = compare_filter.filter(row => row.id !== "operator_groups");
                    let compare_a_result = await this.ascAxios('post', `${this.reactContainerPath}/overview`, {
                        filtered: filter,
                        sorted
                    });
                    let compare_b_result = await this.ascAxios('post', `${this.reactContainerPath}/overview`, {
                        filtered: compare_filter,
                        sorted,
                        compare_flag: true,
                        compare_filterd: filter,
                    });
                    result = {
                        "data" : [
                            compare_a_result.data, 
                            compare_b_result.data
                        ]
                    };
                    break;
                default:
                    break;
            }
            if ((view_level === this.state.view_level) && result && result.data) {
                this.setState({
                    data: result.data,
                    refresh_key: randomId,
                    display_tag,
                    display_tag_list: display_tag,
                    count_msg_flag
                });
            }
        } catch (err) {
            console.error(err);
            this.showErrorObjectMesssage(err, "DataSelectError");
        } finally {
            let routesApp = document.getElementById('routes-app');
            if (routesApp) routesApp.style.overflowY = '';
            this.setState({
                loading: false
            });
        }
    }

    DownloadData = (category) => {
        try {
            this.blockUI();
            let csv_title = null;
            switch (category) {
                case "call_result":
                    csv_title = 
                        moment().utc().add(9, "h").format("YYYYMMDD") +
                        "_call_memo";
                    break;
                default:
                    csv_title =
                        moment().utc().add(9, "h").format("YYYYMMDD") +
                        "_heatmap_" +
                        this.getFilterData("summary_method") +
                        "_number_of_call";
                    break;
            }
            // アクセスログ保存
            try {
                const company = this.getFilterData("cm12_id");
                const start_datetime = this.getFilterData("start_datetime");
                const end_datetime = this.getFilterData("end_datetime");
                this.saveAccessLogs({
                    resource: `${this.reactContainerPath}/csvDownload`,
                    body: {
                        category,
                        csv_title,
                        view_level: this.state.view_level,
                        summary_method: this.getFilterData("summary_method"),
                        inout_type: this.getFilterData("inout_type"),
                        company_id: company && company.value ? company.value : null,
                        company_name: company && company.label ? company.label : null,
                        start_datetime: start_datetime ? moment(start_datetime).format("YYYY-MM-DD HH:mm:ss") : null,
                        end_datetime: end_datetime ? moment(end_datetime).format("YYYY-MM-DD HH:mm:ss") : null,
                    }
                });
            } catch (e) {
                // ログ保存失敗はユーザー操作を妨げない
                console.error(e);
            }

            this.setState({
                csvTitle: csv_title
            }, () => {
                category === "call_result" ? 
                    this.csvLinkCallResult.current.link.click() :
                    this.csvLink.current.link.click()
            });
        } catch (err) {
            console.log(err);
            this.showErrorObjectMesssage(err);
        } finally {
            setTimeout(() => {
                this.unblockUI();
            }, 500);
        }
    }

    createDownloadData = (level, category) => {
        let {
            data
        } = this.state;

        try {
            let csv_data = [];
            switch (category) {
                case "call_result":
                    let call_result_header = ["大項目", "ランク", "詳細項目", "件数", "出現率"];
                    
                    csv_data.push(call_result_header);

                    if (data && data.call_result && data.call_result.data) {
                        // 大項目
                        data.call_result.data.forEach(row => {
                            csv_data.push([row.name, "-", "-", row.count, `${row.percentage}${this.props.langText.Body.Percent}`]);
    
                            // ランク
                            row.children.forEach(rank => {
                                csv_data.push([row.name, rank.name, "-", rank.count, `${rank.percentage}${this.props.langText.Body.Percent}`]);
    
                                // コール結果詳細項目
                                rank.children.forEach(child => {
                                    csv_data.push([row.name, rank.name, child.name, child.count, `${child.percentage}${this.props.langText.Body.Percent}`]);
                                });
                            });
                        });
                    }
                    break;
            
                default:
                    let hours = [];
                    let header = ["通話時間帯", "日曜", "月曜", "火曜", "水曜", "木曜", "金曜", "土曜"];

                    for (let i = 0; i < 24; i++) {
                        let hour =  i + ":00";
                        hours.push(hour); 
                    }
                    
                    csv_data.push(header);

                    hours.forEach((hour, index) => {
                        let data_arr = [];

                        data_arr.push(hour);

                        if (data && data.heatmap) {
                            data.heatmap.forEach(map_data => {
                                let level_data = 0;
            
                                if (level === "all") level_data = map_data.value[index].all;
                                else if (level === "out") level_data = map_data.value[index].out;
                                else if (level === "in") level_data = map_data.value[index].in;
            
                                if (this.hasDecimal(level_data)) level_data = level_data.toFixed(1);

                                data_arr.push(level_data);
                            });
                        }

                        csv_data.push(data_arr);
                    });
                    break;
            }
            

            return csv_data;
        } catch (err) {
            console.log(err);
            this.showErrorObjectMesssage(err);
        }
    }

    hasDecimal = (num) => {
        return num.toString().includes('.');
    }

    getCsvFileName() {
        let date = this.getFilterData("start_datetime");
        let file_name = "";
        if (!!date) {
            file_name = moment(this.getFilterData("start_datetime")).format("YYYYMMDD") + "_";
        }
        let nowTime = moment().utc().add(9, 'h').format("YYYYMMDDhhmmss");
        let viewModeList = this.props.langText.Body.CallAnalysisSummaryViewModeList;
        let viewLevel = viewModeList[this.state.view_level];

        return file_name + this.props.langText.Body.CallAnalysisSummary + "_" + 
                viewLevel + "_" + nowTime + ".csv";
    }

    callAnalysisSummaryCsvDL = async () => {
        try {
            this.blockUI();
            let filtered_idx = this.state.hidden_filtered.findIndex(row => row.id === "cm12_id");
            let company_id = filtered_idx !== -1 ? this.state.filtered[filtered_idx].value.value : null;
            let display_tag = await this.getTagsInfoList(company_id);
            let result = await this.ascAxios('post', `${this.reactContainerPath}/summary`, {
                filtered: this.state.hidden_filtered,
                sorted: this.state.sorted,
                summary_base: this.state.summary_base,
                display_tag,
                // サマリーグループ情報を送信（オペレーター時のみ使用）
                summary_group: this.state.summary_group
            });
            let headers = this.state.base_headers;

            if(result.data.length === 0){
                return this.showErrorObjectMesssage({message: "Download_Failed"});
            } else if (this.state.summary_base === "default") {
                if (this.state.view_level === "CallAnalysisSummaryByOperator") {
                    headers = headers.map((item) => item.key === "key_as_string" 
                        ? { ...item, label: this.props.langText.Body.OperatorName} : item);
                    // OP+グループ時は先頭にグループ名列を追加
                    if (this.state.summary_group === "group") {
                        headers = [
                            { key: "group_name", label: this.props.langText.Body.OperatorGroupName },
                            ...headers
                        ];
                    }
                } else if (this.state.view_level === "CallAnalysisSummaryByExtensionNumber") {
                    headers = headers.map((item) => item.key === "key_as_string" 
                        ? { ...item, label: this.props.langText.Body.ExtensionNumber} : item);
                } else {
                    headers = headers.map((item) => item.key === "key_as_string" 
                        ? { ...item, label: this.props.langText.Body.Date} : item);
                }
            } else {
                if (this.state.view_level === "CallAnalysisSummaryByOperator") {
                    headers = [{ ...headers[0], label: this.props.langText.Body.OperatorName }, { ...headers[1] }];
                    if (this.state.summary_group === "group") {
                        headers = [
                            { key: "group_name", label: this.props.langText.Body.OperatorGroupName },
                            ...headers
                        ];
                    }
                } else if (this.state.view_level === "CallAnalysisSummaryByExtensionNumber") {
                    headers = [{ ...headers[0], label: this.props.langText.Body.ExtensionNumber }, { ...headers[1] }];
                } else {
                    headers = [{ ...headers[0], label: this.props.langText.Body.Date }, { ...headers[1] }];
                }

                display_tag.forEach(row => {
                    headers.push({ key: `tag_per_${row.value}.value`, label: row.label });
                });
            }

            let csvData = this.csvDataFactory(result.data);

            await new Promise((resolve) => {
                this.setState({
                    csvdata: csvData,
                    headers
                }, resolve);
            });

            // アクセスログ保存（CSVダウンロード）
            try {
                const company = this.getFilterData("cm12_id");
                const start_datetime = this.getFilterData("start_datetime");
                const end_datetime = this.getFilterData("end_datetime");
                this.saveAccessLogs({
                    resource: `${this.reactContainerPath}/csvDownload`,
                    body: {
                        category: "summary",
                        file_name: this.getCsvFileName(),
                        view_level: this.state.view_level,
                        summary_base: this.state.summary_base,
                        inout_type: this.getFilterData("inout_type"),
                        company_id: company && company.value ? company.value : null,
                        company_name: company && company.label ? company.label : null,
                        start_datetime: start_datetime ? moment(start_datetime).format("YYYY-MM-DD HH:mm:ss") : null,
                        end_datetime: end_datetime ? moment(end_datetime).format("YYYY-MM-DD HH:mm:ss") : null,
                    }
                });
            } catch (e) {
                // ログ保存失敗は処理続行
                console.error(e);
            }

            return this.csvLink.current.link.click();
        } catch (e) {
            return this.showErrorObjectMesssage(e, "DataSelectError");
        } finally {
            this.unblockUI();
        }
    }

    addZero(num) {
        return ((num < 10) ? '0' : '') + num
    }

    csvDataFactory(dataArr) {
        // 集計オブジェクトから数値を取得するヘルパー
        // 中央値(values['50.0']) → 平均値(value) → doc_count の優先順で参照
        const getAggValue = (agg) => {
            if (!agg) return null;
            if (agg.values && agg.values['50.0'] !== undefined) return agg.values['50.0'];
            if (agg.value !== undefined) return agg.value;
            if (agg.doc_count !== undefined) return agg.doc_count;
            return null;
        };

        try {
            let lastGroupName = "";
            let keyLabel = "";
            dataArr.forEach(data => {
                if (this.state.view_level === "CallAnalysisSummaryByOperator" && this.state.summary_group === "group") {
                    if (data && data.is_group) {
                        lastGroupName = data.key_as_string || "";
                        data.group_name = lastGroupName;
                        // グループ行はオペレーター名列を「平均値」or「中央値」として表示する
                        data.key_as_string = keyLabel;
                    } else {
                        // 最上位(全体)の平均/中央値行はグループ名を「全体」に固定
                        if (data && (data.key_as_string === "average" || data.key_as_string === "median")) {
                            data.group_name = this.props.langText.Body.CallAnalysisSummaryOverviewModeList.CallAnalysisSummaryOverview; // 全体
                        } else {
                            // メンバー行には直前のグループ名を設定
                            data.group_name = lastGroupName;
                        }
                    }
                }
                Object.keys(data).forEach(key => {
                    let display_data = "";
                    let aggVal = null;

                    switch(key) {
                        case "key_as_string":
                            if (data[key] === "average") {
                                data[key] = this.props.langText.Body.AverageValue;
                                keyLabel = data[key];
                            } else if (data[key] === "median") {
                                data[key] = this.props.langText.Body.MedianValue;
                                keyLabel = data[key];
                            } else if (data[key] !== "average" && data[key] !== "median") {
                                switch (this.state.view_level) {
                                    case "CallAnalysisSummaryByExtensionNumber":
                                        if (data[key] === "none") {
                                            data[key] = this.props.langText.Body.ExtensionNumberNotFound;
                                        }
                                        break;
                                    case "CallAnalysisSummaryByOperator":
                                        if (data[key] === "none") {
                                            data[key] = this.props.langText.Body.OperatorNotFound;
                                        }
                                        break;
                                    case "CallAnalysisSummaryByDay":
                                        data[key] = moment(data[key]).format("YYYY-MM-DD");
                                        break;
                                    case "CallAnalysisSummaryByWeek":
                                        data[key] = `${moment(data[key]).format("YYYY-MM-DD")} ~ ${moment(data[key]).add(6, "days").format("YYYY-MM-DD")}`;
                                        break;
                                    case "CallAnalysisSummaryByMonth":
                                        data[key] = `${moment(data[key]).format("YYYY-MM")}`;
                                        break;
                                }
                            }
                            break;
                        case "total_call_count": 
                        case "silence_count":
                        case "talk_conflict_count": 
                        case "rallying_count": 
                            aggVal = getAggValue(data[key]);
                            if (aggVal) {
                                display_data = parseFloat(aggVal.toFixed(2)).toLocaleString();
                            } else {
                                display_data = 0;
                            }
                            data[key].value = display_data + ` ${this.props.langText.Body.TimeCount}`;
                            break;
                        case "total_billsec":
                        case "billsec": 
                            aggVal = getAggValue(data[key]);
                            if (aggVal) {
                                let hour = parseInt(aggVal / 3600);
                                let min = parseInt((aggVal % 3600) / 60);
                                let sec = parseInt(aggVal % 60);
                                display_data = this.addZero(hour) + ":" + this.addZero(min) + ":" + this.addZero(sec);
                            } else {
                                display_data = "00:00:00";
                            }
                            data[key].value = display_data;
                            break;
                        case "billsec_le_30_count":
                        case "billsec_30_60_count":
                        case "billsec_60_180_count":
                        case "billsec_180_300_count":
                        case "billsec_ge_300_count":
                            const countValue = getAggValue(data[key]) || 0;
                            display_data = parseFloat(countValue.toFixed ? countValue.toFixed(2) : countValue).toLocaleString();
                            
                            const totalConn = getAggValue(data["total_connection_count"]) || 0;
                            const percentDisplay = (totalConn && totalConn > 0) ? Math.round((countValue / totalConn) * 100).toLocaleString() : 0;
                            data[key].value = `${display_data} ${this.props.langText.Body.TimeCount} (${percentDisplay}${this.props.langText.Body.Percent})`;
                            break;
                        case "total_score": 
                            aggVal = getAggValue(data[key]);
                            if (aggVal) {
                                display_data = parseInt(aggVal).toLocaleString();
                            } else {
                                display_data = 0;
                            }
                            const scoreMaxUnit = `/${this.state.ct607_settings ? this.state.ct607_settings.score_max : 100}`;
                            data[key].value = display_data + scoreMaxUnit;
                            break;
                        case "talk_per":
                            aggVal = getAggValue(data[key]);
                            if (aggVal) {
                                display_data = parseFloat(aggVal.toFixed(2)).toLocaleString();
                            } else {
                                display_data = 0;
                            }
                            data[key].value = display_data + " %";
                            break;
                        case "operator_talk_speed":
                            aggVal = getAggValue(data[key]);
                            if (aggVal) {
                                display_data = parseFloat(aggVal.toFixed(2)).toLocaleString();
                            } else {
                                display_data = 0;
                            }
                            data[key].value = display_data + ` ${this.props.langText.Body.CharactersPerSecond}`
                            break;
                        case "operator_talk_speed_diff":
                            aggVal = getAggValue(data[key]);
                            if (aggVal && aggVal != "NaN" && isFinite(aggVal)) {
                                display_data = parseFloat(aggVal.toFixed(2)).toLocaleString();
                            } else {
                                display_data = 0;
                            }
                            data[key].value = display_data;
                            break;
                        case "operator_frequency_average":
                            aggVal = getAggValue(data[key]);
                            if (aggVal) {
                                display_data = parseFloat(aggVal.toFixed(2)).toLocaleString();
                            } else {
                                display_data = 0;
                            }
                            data[key].value = display_data + " Hz";
                            break;
                        case "operator_frequency_average_diff":
                        case "operator_accent":
                        case "operator_accent_diff":
                            aggVal = getAggValue(data[key]);
                            if (aggVal) {
                                display_data = parseFloat(aggVal.toFixed(2)).toLocaleString();
                            } else {
                                display_data = 0;
                            }
                            data[key].value = display_data;
                            break;
                        case "filler_count":
                            aggVal = getAggValue(data[key]);
                            if (aggVal !== null && aggVal !== undefined) {
                                display_data = parseFloat(aggVal.toFixed(2)).toLocaleString();
                            } else {
                                display_data = 0;
                            }
                            data[key].value = `${display_data} ${this.props.langText.Body.CountPerMinute}`;
                            break;
                        case "total_connection_count":
                            let connection_rate = "0";
                            aggVal = getAggValue(data[key]);
                            if (aggVal) {
                                display_data = parseFloat(aggVal.toFixed(2)).toLocaleString();
                                const connCountVal = getAggValue(data["connection_count"]);
                                connection_rate = connCountVal
                                ? parseFloat(connCountVal.toFixed(2) * 100).toFixed(0).toLocaleString() : "0";
                            } else {
                                display_data = 0;
                            }
                            data[key].value = display_data + ` ${this.props.langText.Body.TimeCount}` + 
                                " (" + connection_rate + this.props.langText.Body.Percent + ")";
                            break;
                        default:
                            if (key.indexOf("tag_per_") !== -1) {
                                aggVal = getAggValue(data[key]);
                                if (aggVal) {
                                    display_data = parseFloat(aggVal.toFixed(2)).toLocaleString();
                                } else {
                                    display_data = 0;
                                }
                                data[key].value = display_data + " %";
                            }
                            break;
                    }
                }) 
            });

            return dataArr;
        } catch(err) {
            console.error(err);
        }
    }

    getTemplateFilterData = (param, compare_flag) => {
        let {
            templateSelected,
            compareTemplateSelected
        } = this.state;
        let template = compare_flag ? compareTemplateSelected : templateSelected;
        let template_json = template ? template.template_json : null;
        let template_filtered = template_json ? template_json.filtered : null;
        let result = template_filtered 
            ? param === "start_datetime" || param === "end_datetime" 
                ? moment.tz(template_filtered.find(row => row.id === param).value, "Asia/Tokyo")
                : template_filtered.find(row => row.id === param) ? template_filtered.find(row => row.id === param).value : ""
            : this.getFilterData(param, compare_flag);
        
        return result;
    }

    modalShow = (param, modalType, compare_flag) => event => {
        event.preventDefault();
        let {
            templateSelected,
            compareTemplateSelected
        } = this.state;

        let start_datetime = this.getTemplateFilterData("start_datetime", compare_flag);
        let start_ji = this.getTemplateFilterData("start_ji", compare_flag);
        let start_hun = this.getTemplateFilterData("start_hun", compare_flag);
        let end_datetime = this.getTemplateFilterData("end_datetime", compare_flag);
        let end_ji = this.getTemplateFilterData("end_ji", compare_flag);
        let end_hun = this.getTemplateFilterData("end_hun", compare_flag);
        let weekday_selected = this.getTemplateFilterData("weekday_selected", compare_flag);
        let template = compare_flag ? compareTemplateSelected : templateSelected;
        let setData = {
            show: true,
            modalType,
            start_datetime,
            start_ji,
            start_hun,
            end_datetime,
            end_ji,
            end_hun,
            weekday_selected,
            compare_flag
        };

        switch (modalType) {
            case "templateInsert":
                setData = {
                    ...setData,
                    periodSetting: this.state.summary_period_select[0],
                    templateName: ""
                }
                break;
            case "templateCopy":
                setData = {
                    ...setData,
                    periodSetting: template.template_json.period,
                    templateName: ""
                }
                break;
            case "templateUpdate":
            case "templateDelete":
                setData = {
                    ...setData,
                    periodSetting: template.template_json.period,
                    templateName: template.template_name
                }
                break;
            default:
                break;
        }

        this.setState(setData);
    }

    getModalBranch = () => {
        switch (this.state.modalType) {
            case "templateInsert":
            case "templateUpdate":
            case "templateCopy":
                return (
                    <CallAnalysisSummaryTemplateModal
                        userInfo={this.props.userInfo}
                        state={this.state}
                        propSetState={(state) => { if (state.show === false) state.modalType = null; this.propSetState(state); }}
                        langText={this.props.langText}
                        charaLimit={this.props.charaLimit}
                        onClick={this.onClickHandle}
                        getFilterData={this.getFilterData}
                        currentPermission={this.props.currentPermission}
                        validationHandle={this.validationHandle}
                        onTextChange_Limit={this.onTextChange_Limit}
                        onSelectChange={this.onSelectChange}
                        onChange={this.onChange}
                        getTitle={this.getTitle}
                        onMultiSelectChange={this.onMultiSelectChange}
                        onKeyDownIntCheck={this.onKeyDownIntCheck}
                        onTimeChange={this.onTimeChange}
                    />
                );
            case "templateDelete":
                return (
                    <CallAnalysisSummaryTemplateCheckModal
                        userInfo={this.props.userInfo}
                        state={this.state}
                        propState={this.state}
                        propSetState={(state) => { if (state.show === false) state.modalType = null; this.propSetState(state); }}
                        langText={this.props.langText}
                        charaLimit={this.props.charaLimit}
                        onClick={this.onClickHandle}
                        getFilterData={this.getFilterData}
                        currentPermission={this.props.currentPermission}
                        validationHandle={this.validationHandle}
                        onChange={this.onChange}
                        getTitle={this.getTitle}
                    />
                );
            default:
                break;
        }
    }

    getTitle = () => {
        let {
            modalType
        } = this.state;
        let title = null;

        switch (modalType) {
            case "templateInsert":
            case "templateCopy":
                title = this.props.langText.Body.CallAnalysisTemplateInsert;
                break;
            case "templateUpdate":
                title = this.props.langText.Body.CallAnalysisTemplateUpdate;
                break;
            case "templateDelete":
                title = this.props.langText.Body.CallAnalysisTemplateDelete;
                break;
        
            default:
                break;
        }

        return title;
    }

    onClickHandle = async (modalType, compare_flag) => {
        let {
            filtered,
            compare_filtered,
            templateSelected,
            compareTemplateSelected,
            templateName,
            type,
            periodSetting
        } = this.state;

        // template json作成
        let add_filtered_item = ["start_ji", "start_hun", "end_ji", "end_hun", "weekday_selected"];
        let filter = compare_flag ? compare_filtered : filtered;
        let selected = compare_flag ? compareTemplateSelected : templateSelected;

        for (let i = 0; i < filter.length; i++) {
            switch (filter[i].id) {
                case "start_datetime":
                case "start_ji":
                case "start_hun":
                case "end_datetime":
                case "end_ji":
                case "end_hun":
                case "weekday_selected":
                    filter[i].value = this.state[filter[i].id];
                    add_filtered_item = add_filtered_item.filter(row => row !== filter[i].id);
                    break;
                default:
                    break;
            }
        }
        add_filtered_item.forEach(row => {
            if (this.state[row]) filter.push({id: row, value: this.state[row]});
        });

        let template_json = {
            filtered: filter,
            period: periodSetting
        }

        try {
            switch (modalType) {
                case "templateInsert":
                case "templateCopy":
                    this.blockUI();
                    const insertResult = await this.insertTemplate(type, templateName, template_json, "/Summary/CallAnalysisSummary/insertTemplate");

                    if (insertResult) alert(this.props.langText.Message.DataInsertSuccess);
                    break;
                case "templateUpdate":
                    this.blockUI();
                    const updateResult = await this.updateTemplate(selected.id, templateName, template_json, "/Summary/CallAnalysisSummary/updateTemplate");
    
                    if (updateResult) alert(this.props.langText.Message.DataUpdateSuccess);
                    break;
                case "templateDelete":
                    this.blockUI();
                    const deleteResult = await this.deleteTemplate(selected.id, "/Summary/CallAnalysisSummary/deleteTemplate");
    
                    if (deleteResult) alert(this.props.langText.Message.DataDeleteSuccess);
                    break;
                default:
                    break;
            }

            await this.setTemplateInfoList(this.state.type);
            let template = null;
            
            if (modalType === "templateCopy" || modalType === "templateUpdate") {
                template = this.state.templateSelect.filter(row => row.id === selected.id)[0];
            }
            this.onSelectChange(template, "templateSelected", compare_flag);
            if (modalType === "templateDelete") this.onClear();

            this.setState({ show: false, modalType: null });
        } catch (err) {
            console.error(err);
            this.showErrorObjectMesssage(err);
        }
    }

    // フィルターとテンプレートのコール結果・ランク関連チェック
    checkCallResultInTemplateToFilter = (template_filtered, filtered) => {
        let flag = false;
        let call_result_filter_template = template_filtered.find(row => row.id === "call_result_filter");
        let call_result_exclusion_template = template_filtered.find(row => row.id === "call_result_exclusion");
        let call_result_filter_filtered = filtered.find(row => row.id === "call_result_filter");
        let call_result_exclusion_filtered = filtered.find(row => row.id === "call_result_exclusion");

        if (call_result_filter_filtered || call_result_filter_template) {
            let filtered = call_result_filter_filtered ? call_result_filter_filtered.value : null;
            let template = call_result_filter_template ? call_result_filter_template.value : null;
        
            if (!filtered) flag = true;
            else if (!template) flag= true;
            else {
                let idx = 0;
                for (const row of filtered) {
                    let item_flag = template.some(item => 
                        item.value.cm64_id === row.value.cm64_id 
                        && item.value.cm65_id === row.value.cm65_id 
                        && item.value.level === row.value.level
                        && item.value.rank_type === row.value.rank_type
                    );

                    if (item_flag) idx++;
                    else break;
                };

                flag = idx === filtered.length;
            }
        }

        if ((call_result_exclusion_filtered || call_result_exclusion_template) && !flag) {
            let filtered = call_result_exclusion_filtered ? call_result_exclusion_filtered.value : null;
            let template = call_result_exclusion_template ? call_result_exclusion_template.value : null;
        
            if (!filtered) flag = true;
            else if (!template) flag= true;
            else {
                let idx = 0;
                for (const row of filtered) {
                    let item_flag = template.some(item => 
                        item.value.cm64_id === row.value.cm64_id 
                        && item.value.cm65_id === row.value.cm65_id 
                        && item.value.level === row.value.level
                        && item.value.rank_type === row.value.rank_type
                    );

                    if (item_flag) idx++;
                    else break;
                };

                flag = idx === filtered.length;
            }
        }

        return flag;
    }

    render() {
        let col = this.state.view_level === "CallAnalysisSummaryCompare" ? 6 : 12;

        return (
            <BlockUi tag="div" blocking={this.state.blocking} message={this.props.langText.Body.Wait} keepInView>
                {this.state.loading && (
                    <div className="loading-overlay">
                        <div className="spinner"></div>
                        <div className="loading-text">{this.props.langText.Body.Wait}</div>
                    </div>
                )}
                <Col xs={12} sm={12} className="padding-0">
                    <SetBreadCrumb
                        displayItems={[
                            { link: "/Summary", name: this.props.langText.Body.Summary },
                            { name: this.props.langText.Body.CallAnalysisSummary },
                        ]}
                    />
                        <Row className="margin-bottom-20">
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Col className="view_mode pull-left margin-bottom-05">
                                    {this.getOverviewModeInfo()}
                                </Col>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Col className="view_mode pull-left">
                                    {this.getViewModeInfo()}
                                </Col>
                                {(this.state.view_level === "CallAnalysisSummaryByOperator" || this.state.view_level === "CallAnalysisSummaryByExtensionNumber") &&
                                    this.state.count_msg_flag &&
                                    <Col sm={9} md={9} lg={4}>
                                        <label className="search-message">{this.props.langText.Message.CallAnalysisSummaryCountLimit}</label>
                                    </Col>
                                }
                                {(this.state.view_level === "CallAnalysisSummaryByOperator" || this.state.view_level === "CallAnalysisSummaryByDay" ||
                                    this.state.view_level === "CallAnalysisSummaryByWeek" || this.state.view_level === "CallAnalysisSummaryByMonth" ||
                                    this.state.view_level === "CallAnalysisSummaryByExtensionNumber") &&
                                    <Col xs={3} sm={3} md={3} lg={3} className="csv_download pull-right padding-right-0 margin-left-05">
                                        <Col xs={2} sm={2} md={2} lg={2} className="padding-right-0 margin-top-05">
                                            <Button
                                                bsStyle="default"
                                                bsSize = "xsmall"
                                                onClick={this.callAnalysisSummaryCsvDL}>
                                                <FontAwesomeIcon icon={faCloudDownloadAlt} />
                                            </Button>
                                            <CSVLink
                                                data={this.state.csvdata}
                                                headers={this.state.headers}
                                                filename={this.getCsvFileName()}
                                                className="hidden"
                                                ref={this.csvLink}
                                                />
                                        </Col>
                                        <Col xs={10} sm={10} md={10} lg={10} className="padding-right-0">
                                            <MultiSelect
                                                key="display_col"
                                                hasSelectAll={true}
                                                options={this.state.summary_base === "default" ? this.state.display_col_list : this.state.display_tag_list}
                                                value = {this.state.summary_base === "default" ? this.state.display_col : this.state.display_tag}
                                                onChange={(e) => {
                                                    this.state.summary_base === "default" ?
                                                    this.setState({
                                                        display_col: e,
                                                        refresh_key: e
                                                    }) :
                                                    this.setState({
                                                        display_tag: e,
                                                        refresh_key: e
                                                    });
                                                }}
                                                overrideStrings={{
                                                    selectSomeItems: this.props.langText.SelectOption.Placeholder,
                                                    allItemsAreSelected: this.props.langText.Body.AllSelected,
                                                    selectAll: this.props.langText.MultiSelect.AllSelect,
                                                    search: this.props.langText.Body.Search,
                                                }}
                                            />
                                        </Col>
                                    </Col>
                                }
                            </Col>
                        </Row>
                    <div className="view">
                        {this.state.view_level === "CallAnalysisSummaryOverview" && 
                            <Overview
                                state={this.state}
                                data={this.state.data}
                                langText={this.props.langText}
                                csvTitle={this.state.csvTitle} 
                                csvLink={this.csvLink} 
                                csvLinkCallResult={this.csvLinkCallResult}
                                onSummary={this.onSummary}
                                DownloadData={this.DownloadData}
                                createDownloadData={this.createDownloadData}
                                ct607Settings={this.state.ct607_settings}
                            />}
                        {(this.state.view_level === "CallAnalysisSummaryByOperator" || this.state.view_level === "CallAnalysisSummaryByDay" ||
                            this.state.view_level === "CallAnalysisSummaryByWeek" || this.state.view_level === "CallAnalysisSummaryByMonth" ||
                            this.state.view_level === "CallAnalysisSummaryByExtensionNumber") &&
                            <Summaries
                                key={this.state.refresh_key}
                                propSetState={this.propSetState}
                                onSummary={this.onSummary}
                                boardWidth={this.props.boardWidth}
                                langText={this.props.langText}
                                state={this.state}
                                data={this.state.data}
                                ct607Settings={this.state.ct607_settings}
                                collapsedGroups={this.state.collapsedGroups}
                                onToggleGroup={this.onToggleGroup}
                            />}
                        {this.state.view_level === "CallAnalysisSummaryCompare" &&
                            <Compare
                                state={this.state}
                                data={this.state.data}
                                langText={this.props.langText}
                                csvTitle={this.state.csvTitle} 
                                csvLink={this.csvLink} 
                                onSummary={this.onSummary}
                                DownloadData={this.DownloadData}
                                createDownloadData={this.createDownloadData}
                                getFilterData={this.getFilterData}
                                ct607Settings={this.state.ct607_settings}
                            />}
                    </div>
                </Col>
                <Col xs={0} sm={0}>
                    <SearchMenu
                        width={this.state.menu_width}
                        height={this.state.menu_height}>
                        <Col sm={col} md={col} className="padding-0">
                            <Menu
                                state={this.state}
                                userInfo={this.props.userInfo}
                                langText={this.props.langText}
                                getFilterData={this.getFilterData}
                                onChange={this.onChange}
                                onClickAccordion={this.onClickAccordion}
                                validationHandle={this.validationHandle}
                                onKeyDownIntCheck={this.onKeyDownIntCheck}
                                onSelectChange={this.onSelectChange}
                                onMultiSelectChange={this.onMultiSelectChange}
                                onTimeChange={this.onTimeChange}
                                getScopeGreaterEqual={this.getScopeGreaterEqual}
                                onClear={this.onClear}
                                onSummary={this.onSummary}
                                modalShow={this.modalShow}
                            />
                        </Col>
                        {this.state.view_level === "CallAnalysisSummaryCompare" && 
                            <Col sm={6} md={6} className="padding-0">
                                <Menu
                                    state={this.state}
                                    userInfo={this.props.userInfo}
                                    langText={this.props.langText}
                                    getFilterData={this.getFilterData}
                                    onChange={this.onChange}
                                    onClickAccordion={this.onClickAccordion}
                                    validationHandle={this.validationHandle}
                                    onKeyDownIntCheck={this.onKeyDownIntCheck}
                                    onSelectChange={this.onSelectChange}
                                    onMultiSelectChange={this.onMultiSelectChange}
                                    onTimeChange={this.onTimeChange}
                                    getScopeGreaterEqual={this.getScopeGreaterEqual}
                                    onClear={this.onClear}
                                    onSummary={this.onSummary}
                                    modalShow={this.modalShow}
                                    compareFlag={true}
                                />
                            </Col>}
                    </SearchMenu>
                </Col>
                <div className="search-menu-div">
                    <Button
                        className={`search-menu-button ${(this.state.menu_flag && this.state.view_level !== "CallAnalysisSummaryCompare")
                            ? "open" 
                            : (this.state.menu_flag && this.state.view_level === "CallAnalysisSummaryCompare" )
                                ? "open-compare" 
                                : ""}`}
                        onClick={() => this.menuHandle()}
                    >
                        {
                            this.state.menu_flag
                            ? this.props.langText.Body.Quotation
                            : this.props.langText.Body.LessThan
                        }
                    </Button>
                </div> 
                {this.getModalBranch()}
            </BlockUi>
        );
    }
}
